import { Stack, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface LivestockCellDisplayProps {
  value: any
}

export const LivestockCellDisplay = ({ value }: LivestockCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/LivestockEditor')
  const {
    palette: {
      text: { secondary },
    },
  } = useTheme()

  if (value?.input?.species) {
    return (
      <Stack>
        <Typography>
          {t('species', {
            ns: '@cibo/landmanager/LivestockSpecies',
            context: value.input?.species,
          })}
        </Typography>
        <Typography variant="body2" style={{ color: secondary }}>
          {[
            !!value.input?.headCount && t('headCount', { count: value.input?.headCount }),
            !!value.input?.daysGrazing && t('daysGrazing', { count: value.input?.daysGrazing }),
          ]
            .filter(Boolean)
            .join(', ')}
        </Typography>
      </Stack>
    )
  }

  return <Typography>{value?.result ? t('yes') : t('no')}</Typography>
}
